import { SlidesContainerSt } from './MediaSlider.css';
import { MediaData } from '../../utils';
import FullScreenSlides from 'app/shared/components/MediaGallery/components/MediaSlider/components/FullScreenSlides/FullScreenSlides';
import StandardSlides from 'app/shared/components/MediaGallery/components/MediaSlider/components/StandardSlides/StandardSlides';

interface IImageSliderProps {
  fullscreen?: boolean;
  items: MediaData[];
  offset?: number;
  handleMediaGallerySlideClick?: (index: number) => void;
  handleMediaGalleryClick?: (index: number) => void;
  withBackground?: boolean;
  disableFullscreen?: () => void;
  handleBackClick: any;
  handleNextClick: any;
  last?: any;
  disabled?: boolean;
}

const MediaSlider = ({
  fullscreen,
  items,
  offset,
  handleMediaGallerySlideClick,
  handleBackClick,
  handleNextClick,
  handleMediaGalleryClick,
  withBackground,
  disableFullscreen,
  last,
  disabled,
}: IImageSliderProps) => {
  const onImageSlideClick = index => {
    if (handleMediaGallerySlideClick) {
      handleMediaGallerySlideClick(index);
    }
  };

  return (
    <SlidesContainerSt withBackground={withBackground}>
      <StandardSlides
        disabled={disabled}
        offset={offset}
        items={items}
        last={last}
        handleBackClick={handleBackClick}
        handleNextClick={handleNextClick}
        withBackground={withBackground}
        onImageSlideClick={onImageSlideClick}
      />
      {fullscreen && (
        <FullScreenSlides
          offset={offset}
          items={items}
          handleBackClick={handleBackClick}
          handleNextClick={handleNextClick}
          withBackground={withBackground}
          onImageSlideClick={onImageSlideClick}
          disableFullscreen={disableFullscreen}
          handleMediaGalleryClick={handleMediaGalleryClick}
        />
      )}
    </SlidesContainerSt>
  );
};

export { MediaSlider };
